"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloseIcon = void 0;
const epic_games_nav_shared_1 = require("epic-games-nav-shared");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const shared_1 = require("../../../shared");
const Styled = styled_components_1.default.a `
	cursor: pointer;
	opacity: 0.8;
	transition: opacity 0.2s ${(p) => p.theme.easing};
	&:hover {
		opacity: 1;
	}

	&& {
		padding: 13px 14px;
		i {
			font-size: 24px;
			line-height: 24px;
		}
	}

	&:focus {
		outline-offset: -4px;
	}
`;
const CloseIcon = ({ onClick }) => {
    const { messages } = (0, shared_1.useMessages)();
    return (react_1.default.createElement(Styled, { role: "button", tabIndex: 0, title: messages.close || "Close", className: "close-icon", onMouseDown: epic_games_nav_shared_1.stopFocusOnClick, onClick: onClick },
        react_1.default.createElement("i", { className: `eg-header-icon-close` })));
};
exports.CloseIcon = CloseIcon;
//# sourceMappingURL=CloseIcon.atom.js.map